// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Xo-z","slideIn":"Yo-z"};